var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-up"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up",
    clipPath: "url(#clip-up)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18121",
    "data-name": "Path 18121",
    d: "M645.814,160.433l-4.137,4.137a.647.647,0,0,0,.914.915l3.034-3.034V173.5a.647.647,0,0,0,1.293,0V162.451l3.035,3.034a.647.647,0,0,0,.914-.915l-4.137-4.137A.647.647,0,0,0,645.814,160.433Z",
    transform: "translate(-638.775 -159.73)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.cb48082cdb899b535560da051cec1309.svg";
export { ForwardRef as ReactComponent };